import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OnlyDigitsPipe } from '@app/pipes/input-pipes/only-digits.pipe';
import { AlphanumericPipe } from '@app/pipes/input-pipes/alphanumeric.pipe';
import { OnlyLettersPipe } from '@app/pipes/input-pipes/only-letters.pipe';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    OnlyDigitsPipe,
    AlphanumericPipe,
    OnlyLettersPipe,
  ],
  exports: [
    OnlyDigitsPipe,
    AlphanumericPipe,
    OnlyLettersPipe,
  ],
  providers: [
    OnlyDigitsPipe,
    AlphanumericPipe,
    OnlyLettersPipe,
  ]
})
export class InputPipesModule { }
